<template>
    <div>
        <vue-headful :title="'[Reports - '+reportCount+'] - AMOS365'" />

        <h4 class="page-header">
            Saved Reports ({{ reportCount }})
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="reportsTable" url="/reports/list" :columns="columns" :options="options">
                    <template slot="id" slot-scope="props">
                        <router-link :to="`/reports/custom/${props.row.id}`" class="btn btn-xs btn-warning" v-if="props.row.report_type === 'Custom' && canView(props.row)"><i class="fa fa-list"></i> Generate</router-link>
                        <router-link :to="`/reports/downline/${props.row.id}`" class="btn btn-xs btn-warning" v-if="props.row.report_type === 'Downline' && canView(props.row)">
                            <i class="fa fa-list"></i> Generate
                        </router-link>
                    </template>

                    <template slot="report_name" slot-scope="props">
                        <router-link :to="`/reports/view/${props.row.id}`">{{ props.row.report_name }}</router-link>
                    </template>

                    <template slot="is_public" slot-scope="props">
                        <label class="badge badge-info" v-if="props.row.is_public == 1">Public</label>
                        <label class="badge badge-danger" v-else>Private</label>
                    </template>

                    <template slot="user_id" slot-scope="props">
                        {{ props.row.first_name+' '+props.row.last_name }}
                    </template>

                    <template slot="created_at" slot-scope="props">
                        {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>

                    <template slot="updated_at" slot-scope="props">
                        {{ props.row.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                    </template>

                    <template slot="child_row" slot-scope="props">
                        {{ props.row.description }}
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                reportCount: null,
                exportingTable: false,
                userTimezone: this.$root.timezone,
                columns: ['id', 'report_name', 'report_type', 'is_public', 'user_id', 'created_at', 'updated_at'],
                options: {
                    headings: {
                        id: 'Actions',
                        report_name: 'Report',
                        report_type: 'Type',
                        is_public: 'Public',
                        user_id: 'Created By',
                        created_at: 'Created',
                        updated_at: 'Last Updated',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'reports.report_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Reports",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(this.reportCount === null)
                        {
                            //Set the count
                            this.reportCount = response.data.count;
                        }
                        //this.$emit('reportListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {

            canManageReports(){
                //Check Permissions
                return this.$root.hasPermission("reports.manage");
            },
        },

        methods: {
            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                //var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                var cols = JSON.parse(JSON.stringify(this.$refs.reportsTable.columns));

                //Build the payload
                var payload = {
                    //filters: filters,
                    query: (this.$refs.reportsTable.getRequestParams()).query,
                    orderBy: this.$refs.reportsTable.options.orderBy.column,
                    ascending: this.$refs.reportsTable.options.orderBy.ascending,
                    table: 'reportsTable',
                    columns: cols,
                    export: true,
                };

                //Send it
                this.$http.get('/reports', payload)
                    .then(response => {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.e(JSON.stringify(err), 'Failed to Export');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            canView(report){
                //Check if Public
                if(report.is_public == 1)
                {
                    return true;
                }

                //Check permissions
                if(this.$root.hasPermission('reports.manage.all'))
                {
                    return true;
                }

                //Check if user owns the report and has permission
                if(report.user_id == this.$store.state.user.id && this.$root.hasPermission('reports.manage.own'))
                {
                    return true;
                }

                //NOPE
                return false;
            },
        },

        mounted() {

        }
    }
</script>
